var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusBurgundy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Group 19",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 13 Copy"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#97144d",
    strokeMiterlimit: 10,
    strokeWidth: 1.3,
    "data-name": "Group 14 Copy 3"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 9.35
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 18 Copy",
    fill: "none",
    stroke: "#97144d",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 13",
    d: "M6.001 10.091h8.391"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 13 Copy 2",
    d: "M10.092 6v8.391"
  }))));
}
export default SvgPlusBurgundy;